import { render, staticRenderFns } from "./HelpMessageBox.vue?vue&type=template&id=357b48da"
import script from "./HelpMessageBox.vue?vue&type=script&lang=js"
export * from "./HelpMessageBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports